export default "__VITE_ASSET__BeP5KOOV__"